<template>
  <div class="card p-6 mb-2">
    <h6 class="mb-6">Releaseinformationen</h6>
    <div class="d-flex align-items-center" style="gap: 16px">
      <b-form-group v-if="editedSeason.releasefrist?.length === 0" label="Releasefrist">
        <AddRemoveButton @click="onAddReleasefrist" />
      </b-form-group>
      <div v-for="item in editedSeason.releasefrist" :key="'releasefrist-' + item.id">
        <b-form-group class="widthEditField">
          <template #label>
            <div class="d-flex align-items-center" style="gap: 4px">
              <div>{{ `${item.id}. Releasefrist` }}</div>
              <AddRemoveButton
                v-if="editedSeason.releasefrist?.length === item.id"
                @click="onAddReleasefrist"
              />
              <AddRemoveButton
                v-if="editedSeason.releasefrist?.length === item.id"
                @click="onRemoveReleasefrist"
                remove
              />
            </div>
          </template>
          <!-- Feld gilt als geändert, wenn die Frist neu ist (Position über dem geladenen Stand) oder ihr Wert vom Ursprungswert abweicht -->
          <b-form-input
            :class="{
              changed:
                item.id > activeMetadata.releasefrist?.length ||
                +activeMetadata.releasefrist?.[item.id - 1] !== item.value,
            }"
            size="sm"
            v-model="item.value"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import AddRemoveButton from '@/components/common/add-remove-button.vue';

export default {
  name: 'ReisenMetadataCardReleaseinformationen',
  components: { AddRemoveButton },
  props: {
    editedSeason: { type: Object, required: true },
    activeMetadata: { type: Object, default: null },
  },
  methods: {
    // Hängt eine weitere Releasefrist an
    onAddReleasefrist() {
      const length = this.editedSeason.releasefrist.length;
      this.editedSeason.releasefrist = [...this.editedSeason.releasefrist, { value: 0, id: length + 1 }];
    },
    // Entfernt die zuletzt hinzugefügte Releasefrist
    onRemoveReleasefrist() {
      this.editedSeason.releasefrist.pop();
    },
  },
};
</script>

<style lang="scss" scoped>
.widthEditField {
  width: 225px;
}

:deep(.changed) {
  background-color: #3699ff50;
}
</style>
